export const adminDashboard = {
  'admin.dashboard.title': 'Yönetici Paneli',
  'admin.dashboard.subtitle': 'Platform genel bakışı ve temel metrikler',
  'admin.dashboard.totalEarnings.lifetime': 'Toplam Ömür Boyu Kazançlar',
  'admin.dashboard.totalEarnings.lastMonth': 'Geçen Ay Kazançları',
  'admin.dashboard.additionalMetrics': 'Ek Metrikler Yakında',
  'admin.dashboard.charts.accountsProfits': 'Zaman İçinde Trading Hesap Kârları',
  'admin.dashboard.charts.commissionsOverTime': 'Komisyon Geçmişi',
  'admin.dashboard.charts.totalEarnings': 'Zaman İçinde Toplam Kazançlar',
  'admin.dashboard.users.title': 'Toplam Kullanıcılar',
  'admin.dashboard.users.active': 'Aktif Kullanıcılar',
  'admin.dashboard.users.newThisMonth': 'Bu Ay Yeni',
  'admin.dashboard.communityValue.title': 'Toplam Topluluk Değeri',
  'admin.dashboard.communityValue.description': 'Tüm kullanıcı hesaplarının birleşik değeri',
  'admin.dashboard.totalEarnings.accountProfit': 'Hesap Kârı',
  'admin.dashboard.totalEarnings.commissionProfit': 'Komisyon Kârı',
  'admin.dashboard.totalEarnings.description': 'Bugüne kadar birleşik platform kazançları',
  'admin.dashboard.lastMonthEarnings.description': 'Platform kazançları:',
};
